import apiFetch from 'utils/apiFetch';
import { loadingAction } from 'store/globalState/global';
import { joinInNodeRoom } from 'modules/socket/actions';
import { ROOM_THEME_TABLE } from 'constants/rooms';
import history from 'store/history';
import * as ACTION_TYPE from './types';

export const getThinkSeed = (id) => {
  const endPoint = `think-seed/${id}`;

  return apiFetch('GET', { endPoint });
};

export const joinThinkSeed = (id) => {
  const endPoint = `think-seed/${id}/join`;

  joinInNodeRoom(ROOM_THEME_TABLE, id);

  return apiFetch('POST', { endPoint });
};

export const setContributionsInThinkSeed = (id, contributions, other) => {
  const endPoint = `think-seed/${id}/contributions`;

  const params = {
    contributions: contributions.join(','),
    other,
  };

  return apiFetch('POST', { endPoint }, params);
};

export function getMyThinkChats() {
  return (dispatch) => {
    dispatch(loadingAction(true));

    dispatch({
      type: ACTION_TYPE.GET_MY_THINK_CHATS_DATA_INIT,
    });

    apiFetch('GET', { endPoint: 'think-seed/me' }, {})
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.GET_MY_THINK_CHATS_DATA_SUCCESS,
          payload: {
            data,
          },
        });
        dispatch(loadingAction(false));
        data.forEach((table) => {
          joinInNodeRoom(ROOM_THEME_TABLE, table.id);
        });
      })
      .catch(() => {
        dispatch({
          type: ACTION_TYPE.GET_MY_THINK_CHATS_DATA_FAILURE,
        });
        dispatch(loadingAction(false));
      });
  };
}

export const joinThemeTable = table => (dispatch) => {
  dispatch({ type: ACTION_TYPE.JOIN_THINK_CHAT, payload: table });
  joinInNodeRoom(ROOM_THEME_TABLE, table.id);
};

export const updateThemeTable = table => (dispatch) => {
  dispatch({ type: ACTION_TYPE.UPDATE_THINK_CHAT, payload: table });
};

export function changeThinkSeedImage(id, image) {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.CHANGE_THINK_SEED_IMAGE_INIT,
      payload: {
        data: image,
      },
    });

    apiFetch('POST', { endPoint: `think-seed/${id}/image` }, { image })
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.CHANGE_THINK_SEED_IMAGE_SUCCESS,
          payload: {
            data,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: ACTION_TYPE.CHANGE_THINK_SEED_IMAGE_FAILURE,
        });
      });
  };
}

export const leaveThinkChat = (user, chatId) => (dispatch) => {
  dispatch(loadingAction(true));
  const params = {
    userId: user.id,
    chatId,
  };
  dispatch({ type: ACTION_TYPE.LEAVE_THINK_CHAT, payload: { params } });
  apiFetch('POST', { endPoint: `chat/${chatId}/leave` }).then(() => {
    dispatch(loadingAction(false));
    history.push('/think');
  }).catch((error) => {
    console.error('couldn´t leave chat', error);
    dispatch(loadingAction(false));
  });
};

export const getNarrativeThinkChats = narrativeId => (dispatch) => {
  dispatch(loadingAction(true));
  dispatch({ type: ACTION_TYPE.GET_NARRATIVES_THINK_CHATS_INIT, payload: { narrativeId } });
  apiFetch('GET', { endPoint: `narratives/${narrativeId}/think-chats` })
    .then((response) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPE.GET_NARRATIVES_THINK_CHATS_SUCCESS, payload: { narrativeId, thinkChats: response.data } });
    })
    .catch(() => {
      dispatch({ type: ACTION_TYPE.GET_NARRATIVES_THINK_CHATS_FAILURE, payload: { narrativeId } });
      dispatch(loadingAction(false));
    });
};

export const getNarrativeTopics = (narrativeId) => {
  return apiFetch('GET', { endPoint: `narratives/${narrativeId}/think-chats` });
};

export const getUserNarrativeThinkChats = narrativeId => (dispatch) => {
  dispatch(loadingAction(true));
  dispatch({ type: ACTION_TYPE.GET_USER_NARRATIVES_THINK_CHATS_INIT, payload: { narrativeId } });
  apiFetch('GET', { endPoint: `narratives/${narrativeId}/think-chats` }, { user_join: 1 })
    .then((response) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPE.GET_USER_NARRATIVES_THINK_CHATS_SUCCESS, payload: { narrativeId, thinkChats: response.data } });
    })
    .catch(() => {
      dispatch({ type: ACTION_TYPE.GET_USER_NARRATIVES_THINK_CHATS_FAILURE, payload: { narrativeId } });
      dispatch(loadingAction(false));
    });
};

export const getRecommendedTables = (includeInfo = 0, search = '') => {
  return apiFetch('GET', { endPoint: 'recommendations/tables' }, { include_info: includeInfo, search });
};

export const sendTableFeedback = (tableId, feedback, fromType, fromId) => {
  const params = {
    element_type: 'theme_table',
    element_id: tableId,
    accept: feedback,
    from_type: fromType,
    from_id: fromId,
  };
  return apiFetch('POST', { endPoint: 'feedback' }, params);
};



// WEBPACK FOOTER //
// ./src/modules/think-seeds/actions.js